/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

export const EXCEL_COLORS = {
  HEADER_FILL: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF92BBEA' } },
  YEAR_ROW_FILL: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF92BBEA' } },
};
//
export const EXCEL_FONTS = {
  WHITE_BOLD: { color: { argb: 'FFFFFFFF' }, bold: true },
  BOLD: { bold: true },
  NORMAL: { bold: false },
};
//
export const EXCEL_ALIGNMENT = {
  CENTER: { vertical: 'middle', horizontal: 'center' },
  LEFT: { vertical: 'middle', horizontal: 'left' },
};
//
export const EXCEL_BORDERS = {
  THIN: {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  },
  THICK_RIGHT: {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'medium' },
  },
  MEDIUM: {
    top: { style: 'thin' },
    left: { style: 'medium' },
    bottom: { style: 'thin' },
    right: { style: 'medium' },
  },
};
//
export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
//
export const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];
//
export const FILE_FORMATS = [{ label: 'XLSX', type: 'excel' }];

